module.exports = __webpack_public_path__ + "img/model-1.20946671.svg";